import { render } from "react-dom";
import * as React from "react";

import "Styles/Pages/hybrid-anywhere.scss";

import { PageRequestModal } from "./Components/PageRequestModal";
import { DesignContextProvider } from "Components/DesignContext";
import { Button } from "Components/ReactstrapSlim";
import { Provider, useSelector } from "react-redux";
import { CookiesProvider } from "react-cookie";
import { ContactUsModal, FormType } from "Components/Modal";
import { useState } from "react";
import { InputFL } from "Components/Inputs";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { userSelector } from "Utils/selectors";
import { EnterpriseDemoRequestMode } from "Services/API/API";

import lottie from "lottie-web";
import oppotunitiesAnimation from "Assets/lottie/HybridAnywhere/Global";
import solutionsAnimation from "Assets/lottie/HybridAnywhere/Local";

//force asset to be included
import "Assets/img/HybridAnywhere/hybrid-anywhere-benefit1.png";
import "Assets/img/HybridAnywhere/hybrid-anywhere-benefit2.png";
import "Assets/img/HybridAnywhere/hybrid-anywhere-benefit3.png";

import "Assets/img/HybridAnywhere/icon-infinity.svg";
import "Assets/img/HybridAnywhere/icon-matrix.svg";
import "Assets/img/HybridAnywhere/icon-globe.svg";
import "Assets/img/HybridAnywhere/icon-cloud.svg";
import "Assets/img/HybridAnywhere/icon-booking.svg";
import "Assets/img/HybridAnywhere/icon-location.svg";

import "Assets/img/HybridAnywhere/world-map-pins.png";
import assertContainerElement from "Utils/assertContainerElement";


const pageRequestModalRoot = document.getElementById("page-request-modal");
assertContainerElement(pageRequestModalRoot);

render(<DesignContextProvider name="marketing">
   <PageRequestModal />
</DesignContextProvider>, pageRequestModalRoot);

interface PageFormModel {
   email: string
}

const PageFormSchema: yup.SchemaOf<PageFormModel> = yup.object({
   email: yup.string()
      .required("Email is required")
      .email("Email is not valid")
      .defined()
});

const PageForm: React.FC = () => {
   const user = useSelector(userSelector);
   const formMethods = useForm<PageFormModel>({
      mode: "onTouched",
      resolver: yupResolver(PageFormSchema),
      defaultValues: {
         email: user?.email || undefined,
      }
   });
   const [enterpriseRequestModalOpened, setEnterpriseRequestModalOpened] = useState(false);
   const toggleEnterpriseRequestModal = () => {
      setEnterpriseRequestModalOpened((wasOpened) => !wasOpened);
   }
   const onStart = () => {
      formMethods.trigger().then((isValid) => {
         if (isValid)
            toggleEnterpriseRequestModal();
      });
   }


   return (
      <>
         <div className="halp-email-form">
            <InputFL control={formMethods.control} name="email" onDark bsSize="lg" placeholder="Please enter your email..." autocomplete="off" />
            <Button color='primary-on-dark' size='lg' onClick={onStart}>Get&nbsp;started</Button>
         </div>
         {enterpriseRequestModalOpened && <ContactUsModal toggle={toggleEnterpriseRequestModal} isOpen={enterpriseRequestModalOpened} formType={FormType.Specific} mode={EnterpriseDemoRequestMode.HybridAnywhere} email={formMethods.getValues("email")} centered />}
      </>
   )
}

const pageFormRoot = document.getElementById("page-form")!;
render(<DesignContextProvider name="marketing">
   <Provider store={LSStore.instance}>
      <CookiesProvider>
         <PageForm />
      </CookiesProvider>
   </Provider>
</DesignContextProvider>, pageFormRoot);

(function () {
   const observer = new IntersectionObserver(
      ([e]) => {
         if (e.intersectionRatio < 1) {
            e.target.classList.add("halp-header-sticky");
         } else {
            e.target.classList.remove("halp-header-sticky");
         }
      },
      { threshold: [1] }
   );

   observer.observe(document.getElementById("halp-header-wrapper")!);


   function loadAnimetion(elementId: string, animationData: any) {
      const lottieElement1 = document.getElementById(elementId)!;
      lottie.loadAnimation({
         container: lottieElement1, // the dom element that will contain the animation
         renderer: "svg",
         loop: true,
         autoplay: true,
         animationData: animationData
      });
   }

   loadAnimetion("lottieOppotunities", oppotunitiesAnimation as any);
   loadAnimetion("lottieSolutions", solutionsAnimation as any);
})();